<div id='pageLimitWrapper'>
  Show
  <select [ngModel]="selectedValue" id='{{id}}' (ngModelChange)='onChange($event)'>
    <option *ngFor="let option of options" [ngValue]="option">
      {{option}}
    </option>
  </select>
  entries
</div>
